export const getPPRValue = (scoringType: string) => {
  if (scoringType === 'NON-PPR') {
    return 0
  }
  if (scoringType === 'PPR') {
    return 1
  }
  return 0.5
}
